import { render } from "./uv_index_modal.vue?vue&type=template&id=1aca5fd6&scoped=true"
import script from "./uv_index_modal.vue?vue&type=script&lang=js"
export * from "./uv_index_modal.vue?vue&type=script&lang=js"

import "./uv_index_modal.vue?vue&type=style&index=0&id=1aca5fd6&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/WaterQualityFrontEnd_Vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aca5fd6"]])

export default __exports__